module.exports = __webpack_public_path__ + "img/9788932903507.be36828e.jpg";